export default {
  name: 'First-List-Element',
  props: ['firstElement', 'top', 'actualPlay', 'isPlaying', 'mainList', 'listNumber', 'special'],
  data() {
    return {
      isSocial: false,
    }
  },
  methods: {
    toggleSocialElement(){
      this.isSocial = !this.isSocial
    },
    addVote() {
    },
    playMP3(mp3) {
      this.$emit('songURL', mp3);
    },
    goToArtistSite(id) {
      if(!this.$route.path.includes(`/artysta/${id}`)){
        this.$router.push(`/artysta/${id}`)
      }
    },
    goToSong(id) {
      if(!this.$route.path.includes(`/utwór/${id}`)){
        this.$router.push(`/utwór/${id}`)
      }
    },
    makeFacebookLink(id, title){
      return `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Flp3.polskieradio.pl%2Futwór%2F${id}%2F&quote=Zagłosowałem na ${title} w Liście Przebojów Trójki`
    }
  },
  mounted() {
  }
}
